import * as THREE from 'three';
import React, { useMemo } from 'react'
import { const_var, params } from '../../../../redux/reducers/reducer';
import { isColorLight, logoTexture } from '../../../../redux/reducers/utils';

const Watermark = () => {

    useMemo(()=>{
        logoTexture();
    },[const_var.scene && const_var.scene?.getObjectByName("manufacturerLogoFront"),params.endStoragePositionZ,const_var.scene,params.p_w,params.p_h,params.p_d,params.p_r_p,params.p_f_w,params.p_b_w,params.p_u_c,params.p_u_t,params.p_w_c])

    const isLightColor = useMemo(()=>{
        let isLightColor = isColorLight(params.p_w_c.replace('0x','#'))
        return isLightColor
    },[params.p_w_c])

    return (
        <>
            <mesh name="manufacturerLogoFront" visible={false}>
                <planeGeometry args={[1, 1,400,400]}  />
                <meshPhongMaterial color={(isLightColor && const_var.crmSetting.main_domain_url != "eaglebuildings.com" && const_var.crmSetting.parent_api_token != "Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG") ? "#636363" : "#ffffff"} side={THREE.DoubleSide} needsUpdate={true} shininess={1} />
            </mesh>
            
            <mesh name="manufacturerLogoBack" visible={false}>
                <planeGeometry args={[1, 1,400,400]} />
                <meshPhongMaterial side={THREE.DoubleSide} needsUpdate={true} shininess={1}/>
            </mesh>
            
            <mesh name="manufacturerLogoCenter" visible={false}>
                <planeGeometry args={[1, 1,400,400]} />
                <meshPhongMaterial side={THREE.DoubleSide} needsUpdate={true} shininess={1}/>
            </mesh>
    
            
        </>
    )
}

export default Watermark